import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { TooltipModule } from '@platform-frontend/ui-tools';
import { PriceOverviewComponent } from './price-overview/price-overview.component';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';

@NgModule({
  declarations: [PriceOverviewComponent],
  imports: [CommonModule, TooltipModule, TranslocoMarkupModule, TranslocoLocaleModule, TranslocoModule],
  exports: [PriceOverviewComponent]
})
export class CheckoutPricingModule {}
